import { MobileVariant } from "../types";
import styled from "styled-components";
const desktop = (steps, desktopAlign) => {
    let template = "";
    steps.forEach((step) => {
        if (desktopAlign === "left") {
            template += `"step-container-${step.id} content-container"`;
        }
        if (desktopAlign === "right") {
            template += `"content-container step-container-${step.id}"`;
        }
    });
    return template;
};
const mobile = (steps, currentStep) => {
    let template = "";
    steps.forEach((step) => {
        template += `"step-container-${step.id}"`;
        if (currentStep.id === step.id) {
            template += `"content-container"`;
        }
    });
    return template;
};
export const ComplexWrapper = styled.div `
  display: grid;
  width: 100%;

  ${(props) => props.steps.map((step) => `
        & > #step-container-${step.id} {
          grid-area: step-container-${step.id};
        }
      `)}

  & > #content-container {
    grid-area: content-container;
  }

  @media (max-width: 768px) {
    grid-template-areas: ${(props) => mobile(props.steps, props.currentStep)};
    grid-template-columns: auto;
  }

  @media (min-width: 769px) and (max-width: 1069px) {
    grid-template-areas: ${(props) => desktop(props.steps, props.desktopAlign)};
    grid-template-columns: ${(props) => {
    return props.desktopAlign === "left" ? "252px auto" : "auto 252px";
}};
  }
  @media (min-width: 1070px) {
    grid-template-areas: ${(props) => desktop(props.steps, props.desktopAlign)};
    grid-template-columns: ${(props) => {
    return props.desktopAlign === "left" ? "352px auto" : "auto 352px";
}};
  }
`;
export const StepsWrapper = styled.div `
  @media (min-width: 769px) {
    margin-right: 24px;
  }

  & > .icon-box {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 16px;

    & svg {
      width: 64px;
      height: 64px;
    }
  }
`;
export const StepIllustrator = styled.div `
  @media (min-width: 769px) {
    margin-right: 24px;
  }
`;
export const ContentContainer = styled.div `
  width: ${(props) => (props.percentWidth ? `${props.percentWidth}%` : "70%")};
  @media (max-width: 768px) {
    ${(props) => props.mobileVariant === MobileVariant.VERTICAL_LINE &&
    `
        display: grid;
        grid-template-columns: 34px auto;
    `}
  }
`;
export const ContentWrapper = styled.div `
  ${(props) => props.mobileVariant === MobileVariant.VERTICAL_LINE &&
    "padding-left: 20px;"};
  ${(props) => (props.mobileVariant === MobileVariant.VERTICAL_LINE ||
    props.mobileVariant === MobileVariant.VERTICAL_LINE_COMPACT) &&
    "margin: 10px 0;"};
`;
//# sourceMappingURL=styled.js.map